import { render, staticRenderFns } from "./productSubCategory.html?vue&type=template&id=b114156e&scoped=true&"
import script from "./productSubCategory.vue?vue&type=script&lang=js&"
export * from "./productSubCategory.vue?vue&type=script&lang=js&"
import style0 from "./productSubCategory.vue?vue&type=style&index=0&id=b114156e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b114156e",
  null
  
)

export default component.exports